import { COPY_CUT_FILE_DATA } from '../../constants/copyFile';

const copyCutFile = (data) => {
	return {
		type: COPY_CUT_FILE_DATA,
		payload: data
	};
};

export { copyCutFile };
